import { Editor } from "grapesjs";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import { RequiredPluginOptions } from "../../../../../types/types";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  const navigationData = await getApiData(APIS.NAVIGATION, {});
  if (!navigationData || !navigationData.data) {
    console.error("Navigation data is not available!");
    return;
  }

  const currentUrl = window.location.hostname;

  const navLinks = navigationData.data
    .map((link: { path: string; name: string }) => {
      return `<a href="${link.path}" class="text-black font-semibold hover:border-[var(--primary)] hover:border-b-2 px-2">${link.name}</a>`;
    })
    .join("");

  Components.addType("logistic-navbar", {
    isComponent: (el) => {
      if (el.className === "navbar") {
        return {
          type: "logistic-navbar",
        };
      }
    },
    model: {
      defaults: {
        components: /*html*/ `
          <nav class="shadow-lg bg-white w-full navbar">
           <div class="hidden md:block w-full text-white py-1 bg-[#535353] shadow-sm">
              <div class="container mx-auto  px-4 md:px-12 ">
                <div class="flex items-center justify-end w-full">
                  <ul
                    class="flex justify-end gap-x-4 w-full text-white  items-center   md:text-base m-0  text-lg"
                  >
                       <li class="flex items-center text-sm  ">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.0001 1.83368C14.0342 1.83368 16.5001 4.27201 16.5001 7.28785C16.5001 11.3762 11.0001 17.417 11.0001 17.417C11.0001 17.417 5.50008 11.3762 5.50008 7.28785C5.50008 4.27201 7.96591 1.83368 11.0001 1.83368ZM11.0001 5.50035C10.5139 5.50035 10.0475 5.6935 9.70372 6.03732C9.3599 6.38113 9.16675 6.84745 9.16675 7.33368C9.16675 7.81991 9.3599 8.28622 9.70372 8.63004C10.0475 8.97386 10.5139 9.16701 11.0001 9.16701C11.4863 9.16701 11.9526 8.97386 12.2964 8.63004C12.6403 8.28622 12.8334 7.81991 12.8334 7.33368C12.8334 6.84745 12.6403 6.38113 12.2964 6.03732C11.9526 5.6935 11.4863 5.50035 11.0001 5.50035ZM18.3334 17.417C18.3334 19.4428 15.0517 21.0837 11.0001 21.0837C6.94841 21.0837 3.66675 19.4428 3.66675 17.417C3.66675 16.2345 4.78508 15.1803 6.51758 14.5112L7.10425 15.3453C6.11425 15.7578 5.50008 16.3262 5.50008 16.9587C5.50008 18.2237 7.96591 19.2503 11.0001 19.2503C14.0342 19.2503 16.5001 18.2237 16.5001 16.9587C16.5001 16.3262 15.8859 15.7578 14.8959 15.3453L15.4826 14.5112C17.2151 15.1803 18.3334 16.2345 18.3334 17.417Z"
                            fill="currentColor"
                          />
                        </svg>
                        <a href="/our-branches"  class="text-white font-roboto font-semibold"
                          >Our Branches</a
                        >
                      </li>
                    <li class="flex items-center md:text-base   gap-x-2  ">
                      <svg
                        width="22px"
                        height="22px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z"
                            fill="currentColor"
                          ></path>
                        </g>
                      </svg>
                      <a
                        href="https://${currentUrl}"
                        target="_blank"
                        class=" font-roboto font-semibold"
                        >Login</a
                      >
                      <span class="text-white">|</span>
                      <a
                        href="/signup"
                        class="font-roboto font-semibold"
                        >Signup</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="container mx-auto px-4 py-2 flex items-center justify-between"
            >
              <button id="menu-toggle" class="md:hidden p-2 ">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.2918 6.33326C17.2918 6.49902 17.2259 6.658 17.1087 6.77521C16.9915 6.89242 16.8325 6.95827 16.6668 6.95827H3.33326C3.1675 6.95827 3.00852 6.89242 2.89131 6.77521C2.7741 6.658 2.70825 6.49902 2.70825 6.33326C2.70825 6.1675 2.7741 6.00852 2.89131 5.89131C3.00852 5.7741 3.1675 5.70825 3.33326 5.70825H16.6668C16.8325 5.70825 16.9915 5.7741 17.1087 5.89131C17.2259 6.00852 17.2918 6.1675 17.2918 6.33326ZM17.2918 10.5C17.2918 10.6657 17.2259 10.8247 17.1087 10.9419C16.9915 11.0591 16.8325 11.125 16.6668 11.125H3.33326C3.1675 11.125 3.00852 11.0591 2.89131 10.9419C2.7741 10.8247 2.70825 10.6657 2.70825 10.5C2.70825 10.3342 2.7741 10.1753 2.89131 10.058C3.00852 9.94083 3.1675 9.87498 3.33326 9.87498H16.6668C16.8325 9.87498 16.9915 9.94083 17.1087 10.058C17.2259 10.1753 17.2918 10.3342 17.2918 10.5ZM17.2918 14.6667C17.2918 14.8325 17.2259 14.9914 17.1087 15.1087C16.9915 15.2259 16.8325 15.2917 16.6668 15.2917H3.33326C3.1675 15.2917 3.00852 15.2259 2.89131 15.1087C2.7741 14.9914 2.70825 14.8325 2.70825 14.6667C2.70825 14.5009 2.7741 14.342 2.89131 14.2248C3.00852 14.1076 3.1675 14.0417 3.33326 14.0417H16.6668C16.8325 14.0417 16.9915 14.1076 17.1087 14.2248C17.2259 14.342 17.2918 14.5009 17.2918 14.6667Z"
                    fill="#272727"
                  />
                </svg>
              </button>
              <div class="flex items-center justify-center md:justify-left ">
              <a href="/" class="p-2">
                <img
                  id="navbarLogo"
                  src="https://via.placeholder.com/100"
                  alt="Logo"
                  class="w-20 h-16 md:h-20 cursor-pointer object-contain"
                />
                </a>
              </div>
              <div class="hidden md:flex space-x-6 nav-links">${navLinks}</div>
              <div class="hidden md:flex items-center space-x-4">
                <a
                  href="/track"
                  class="w-32 text-center py-2 font-semibold bg-[var(--primary)] text-lg text-white rounded-md shadow"
                >
                  Track
                </a>
              </div>
            </div>
            <div
              id="mobile-menu"
              class="fixed inset-0 z-20 bg-white w-full h-full  transform -translate-x-full transition-transform md:hidden"
            >
              <div class="p-4 ">
                <div class="flex items-center justify-between  ">
                  <img
                    id="navbarLogo"
                    src=""
                    alt="Logo"
                    class="w-20 h-16 md:h-20 cursor-pointer object-contain"
                  />
                  <button id="close-menu" class="p-2 ">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="#0D0D0D"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div class="mt-4 flex flex-col space-y-2 mobile-nav-links text-[var(--primary)]">
                  ${navLinks}
                   <hr />
                    <a href="/track" class=" px-4 py-2">
                      Track Now
                    </a>
                    <hr />
                    <ul class="flex flex-col mt-2 gap-y-2  w-full">
                      <li
                        class="flex items-center gap-x-1  "
                      >
                      <a id="login" href="https://${currentUrl}" target="_blank" class="px-4 py-2">
                       Login
                       </a>
                      </li>
                      <li
                        class="flex items-center gap-x-1  "
                      >
                      <a href="/signup" class="px-4 py-2">
                      SignUp
                       </a>
                      </li>

                    </ul>
                </div>
              </div>
            </div>
          </nav>
        `,

        script: function () {
          const currentPath =
            window.location.pathname.replace(/\/$/, "") || "/";
          const navLinks = document.querySelectorAll(
            ".nav-links a, .mobile-nav-links a"
          );

          // const loginLink = document.getElementById(
          //   "login"
          // ) as HTMLAnchorElement;
          // loginLink.href = window.location.origin;

          function setActiveLink(path) {
            const navLinksArray = Array.from(navLinks);
            navLinksArray.forEach((nav) =>
              nav.classList.remove("border-[var(--primary)]", "border-b-2")
            );
            const activeLink = navLinksArray.find((link) => {
              const linkPath = link.getAttribute("href");
              return linkPath === path;
            });

            if (activeLink) {
              activeLink.classList.add(
                "md:border-[var(--primary)]",
                "md:border-b-2"
              );
            }
          }
          setActiveLink(currentPath);
          document
            .getElementById("menu-toggle")
            .addEventListener("click", function () {
              document
                .getElementById("mobile-menu")
                .classList.remove("-translate-x-full");
            });

          document
            .getElementById("close-menu")
            .addEventListener("click", function () {
              document
                .getElementById("mobile-menu")
                .classList.add("-translate-x-full");
            });
          document
            .querySelectorAll("#mobile-menu .nav-link")
            .forEach((link) => {
              link.addEventListener("click", function () {
                document
                  .getElementById("mobile-menu")
                  .classList.add("-translate-x-full");
              });
            });
        },
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "navbar-edit",
          },
        ],
      },
    },
  });
};
